import { Card, Button, DialogTitle, Snackbar, DialogActions, Backdrop, TableCell, TableContainer, FormControl, Table, Checkbox, FormControlLabel, FormLabel, FormGroup, FormHelperText, TableRow, TableBody, TableHead, Typography, ListItemText, ListItemIcon, ListItem, DialogContent, List, Dialog, CardContent, CardHeader, Container, Grid, IconButton, TextField, TablePagination, Tooltip, InputAdornment, Autocomplete, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import Alert from 'src/components/Alert';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import Tarihce from 'src/views/History';
import ExtensionIcon from '@mui/icons-material/Extension';
import UploadFile from '../../components/UploadFile';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import ExpandableComment from 'src/components/ExpandableComment';

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  container: {
    maxHeight: '100%',
    maxWidth: '100%',
    minWidth: '100%'
  },
  container1: {
    maxHeight: 630,
    maxWidth: '100%',
    minWidth: '100%'
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1),
  }),
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  closeButton: (theme) => ({
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
    color: theme.palette.grey[500],
  }),
  formControl: (theme) => ({
    margin: theme.spacing(3)
  }),
  cardscontent3: {
    minHeight: 50
  },
  cardscontent2: {
    height: 600
  },
  responsiveContainer: (theme) => ({
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "70vh",
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "60vh",
      overflow: 'scroll'
    }
  })
};

const localeMap = {
  tr: trLocale,
};

const currentDate = new Date()

function CloseConfirm() {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const SessionUser = getUser();
  const [durumId, setDurumId] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [applicationId, setApplicationId] = useState(0);
  const [documentType, setDocumentType] = useState(0);
  const [Required, setRequired] = useState(false);
  const [RequiredIhbarSuresiDolumTarihi, setRequiredIhbarSuresiDolumTarihi] = useState(false);
  const [yorumAciklama, setYorumAciklama] = useState('');
  const [generalData, setGeneralData] = useState([]);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [filePopUp, setFilePopUp] = useState(false);
  const [fileList, setFileList] = React.useState([])
  const [tarihcePopUp, setTarihcePopUp] = useState(false);
  const [todoData, setTodoData] = useState([]);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState([]);
  const [selectedYSOnay, setSelectedYSOnay] = useState([]);
  const [todoPopUp, setTodoPopUp] = useState(false);
  const [checkedMenu, setCheckedMenu] = useState([]);
  const [moyOnayPopUp, setMoyOnayPopUp] = useState(false);
  const [ibraProtokoluPopUp, setibraProtokoluPopUp] = useState(false);
  const [kapanisPopUp, setkapanisPopUp] = useState(false);
  const [moyOnOnayPopUp, setMoyOnOnayPopUp] = useState(false);
  const [closeType, setCloseType] = useState(0);
  const [byOnayPopUp, setBYOnayPopUp] = useState(false);
  const [bySonOnayPopUp, setBYSonOnayPopUp] = useState(false);
  const [moySonOnayPopUp, setmoySonOnayPopUp] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [fileTypeData, setFileTypeData] = React.useState([]);
  const [state, setState] = React.useState({
    kural1: false
  });

  const [kapanisTipId, setKapanisTipId] = useState(null)

  const [searchText, setSearchText] = useState('');
  const [filtreKapanisTipi, setFiltreKapanisTipi] = useState(null);
  const [filtreDurum, setFiltreDurum] = useState(null);
  const [filtreBolge, setFiltreBolge] = useState(null);
  const [filtreServisTipi, setFiltreServisTipi] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const kapanisTipiSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.KAPANIS_TIP).filter(Boolean))]
  ), [generalData]);
  const durumSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.DURUM).filter(Boolean))]
  ), [generalData]);
  const bolgeSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.BOLGE).filter(Boolean))]
  ), [generalData]);
  const servisTipiSecenekleri = useMemo(() => (
    [...new Set(generalData.map((row) => row.SERVIS_TIPI).filter(Boolean))]
  ), [generalData]);

  const filteredData = useMemo(() => {
    const arama = searchText.trim().toLocaleLowerCase('tr');
    return generalData.filter((row) => {
      if (filtreKapanisTipi && row.KAPANIS_TIP !== filtreKapanisTipi) return false;
      if (filtreDurum && row.DURUM !== filtreDurum) return false;
      if (filtreBolge && row.BOLGE !== filtreBolge) return false;
      if (filtreServisTipi && row.SERVIS_TIPI !== filtreServisTipi) return false;
      if (!arama) return true;
      const aranacakAlanlar = [row.KAPANIS_TIP, row.DURUM, row.SONRAKI_ADIM_ACIKLAMA, row.BOLGE, row.IL_ILCE, row.SERVIS_TIPI, row.SERVIS_BILGI, row.SERVIS];
      return aranacakAlanlar.some((alan) => alan?.toString().toLocaleLowerCase('tr').includes(arama));
    });
  }, [generalData, searchText, filtreKapanisTipi, filtreDurum, filtreBolge, filtreServisTipi]);

  useEffect(() => {
    setPage(0);
  }, [searchText, filtreKapanisTipi, filtreDurum, filtreBolge, filtreServisTipi]);

  const filtreleriTemizle = () => {
    setSearchText('');
    setFiltreKapanisTipi(null);
    setFiltreDurum(null);
    setFiltreBolge(null);
    setFiltreServisTipi(null);
  };

  const filtreAktifMi = Boolean(searchText || filtreKapanisTipi || filtreDurum || filtreBolge || filtreServisTipi);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { kural1 } = state;

  const [ihbarnameSuresiDolumTarihi, setIhbarnameSuresiDolumTarihi] = useState(null);
  const [IhbarnameSuresiDolumTarihiVisible, setIhbarnameSuresiDolumTarihiVisible] = useState(false);

  const [tododone, setTodoDone] = useState(0);

  useEffect(() => {
    handleGetCloseApplication(1);
    getApolloTodo();
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('id');
    if (myParam) {
      setSelectedIndex(parseInt(myParam));
    }
    let mounted = true;
    return () => {
      mounted = false;
    };
  }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

  const handleGetCloseApplication = (dataUri) => {
    setLoading(true);
    axios.get(`/GetKapanisBasvuruOnay/${SessionUser.TopServiceShopCode}`)
      .then((response) => {
        setLoading(false);
        const res = response.data;
        setGeneralData(Array.isArray(res) ? res : []);
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleReject = () => {
    if ((!yorumAciklama)) {
      setRequired(true);
      return
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "", //okta
      Role_Id: 0, //orta katman
      Durum: durumId,
      CloseType: closeType
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetRejectBasvuruClose', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        handleGetCloseApplication(1);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setSelectedWorkOrderId([]);
        handleGetCloseApplication(1);
        setSelectedYSOnay([]);
        setState({
          kural1: false,
          kural2: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleBeforeConfirm = () => {
    if ((durumId == 7 && kapanisTipId == 1) || (durumId == 7 && kapanisTipId == 3) ||
      (durumId == 2 && kapanisTipId == 5) || (durumId == 13 && kapanisTipId == 2) || (durumId == 5 && kapanisTipId == 4)) {
      if (checkedMenu.length < todoData.length) {
        setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
        setUyariTip("error");
        setUyari(true);
        return;
      }
      setTodoDone(1);
      setTodoPopUp(false);
    }
  }



  const handleSave = () => {
    if ((durumId == 7 && kapanisTipId == 1) || (durumId == 7 && kapanisTipId == 3) ||
      (durumId == 2 && kapanisTipId == 5) || (durumId == 13 && kapanisTipId == 2) || (durumId == 5 && kapanisTipId == 4)) {
      if (tododone == 0) {
        setresponseMessage('Lütfen gerekli adımları tamamlayıp tekrardan deneyiniz!...')
        setUyariTip("error");
        setUyari(true);
        setTodoPopUp(true);
        return;
      }
    }
    if ((durumId == 22 && kural1 == false) && kapanisTipId == 1) {
      setresponseMessage("Lütfen BY Onay Aksiyonlarını tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setDocumentType(100);
      setBYOnayPopUp(true);
      return;
    }
    if ((durumId == 14 && kural1 == false) && kapanisTipId == 1) {
      setresponseMessage("Lütfen aksiyonları tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setibraProtokoluPopUp(true);
      return;
    } if ((durumId == 10 && kural1 == false) && kapanisTipId == 2) {
      setresponseMessage("Lütfen aksiyonları tamamlayınız!...")
      setUyariTip("error");
      setUyari(true);
      handleFileType(selectedIndex);
      setBYSonOnayPopUp(true);
      return;
    }
    var handleError = false;
    if (!yorumAciklama) {
      setRequired(true);
      setSinglePopUp(true);
      handleError = true;
    }
    if ((!ihbarnameSuresiDolumTarihi && IhbarnameSuresiDolumTarihiVisible) || (!ihbarnameSuresiDolumTarihi && moment(ihbarnameSuresiDolumTarihi, 'dd.MM.yyyy').isValid())) {
      setRequiredIhbarSuresiDolumTarihi(true);
      handleError = true;
    }
    if (handleError) {
      return;
    }
    const data = [{
      Id: selectedIndex,
      Yorum: yorumAciklama,
      UserId: "",
      Role_Id: 0,
      Durum: durumId,
      CloseType: closeType,
      IhbarnameSuresiDolumTarihi: ihbarnameSuresiDolumTarihi
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetApolloServisKapanisOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setTodoDone(0);
      }
      if (res.ErrorCode === '0') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setSinglePopUp(false);
        setRequired(false);
        handleGetCloseApplication(1);
        setSelectedWorkOrderId([]);
        setSelectedYSOnay([]);
        setTodoPopUp(false);
        setTodoDone(0);
        setState({
          kural1: false,
          kural2: false
        });
      }
    }).catch(error => {
      setLoading(false);
      setSinglePopUp(false);
    });
  }

  const handleActionPopUp = (row) => {
    if ((row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 13 && row.KAPANIS_TIP_ID == 2) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3) ||
      (row.DURUM_ID == 5 && row.KAPANIS_TIP_ID == 4) ||
      (row.DURUM_ID == 2 && row.KAPANIS_TIP_ID == 5) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3)) {
      setSelectedIndex(row.ID);
      setTodoPopUp(true);
      setDurumId(row.DURUM_ID);
      getApolloTodo();
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 5) ||
      (row.DURUM_ID == 2 && row.KAPANIS_TIP_ID == 2)) {
      setSelectedIndex(row.ID);
      setBYOnayPopUp(true);
      setDocumentType(100)
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 6) ||
      (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 22) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 6) ||
      (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 6)) {
      setSelectedIndex(row.ID);
      setMoyOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 14) ||
      (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 20)
    ) {
      setSelectedIndex(row.ID);
      setibraProtokoluPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 24) || (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 24) ||
      (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 24) || (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 24)) {
      setSelectedIndex(row.ID);
      setkapanisPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 5)) {
      setSelectedIndex(row.ID);
      setMoyOnOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 10)) {
      setSelectedIndex(row.ID);
      setBYSonOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    else if ((row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 18)) {
      setSelectedIndex(row.ID);
      setmoySonOnayPopUp(true);
      handleFileType(row.ID);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
    // if (row.DURUM_ID == 5) {
    //   setSelectedIndex(row.ID);
    //   handleFileType(row.ID);
    //   setMoyOnOnayPopUp(true);
    //   setDurumId(row.DURUM_ID);
    //   setCloseType(row.KAPANIS_TIP_ID)
    // }
    // else if (row.DURUM_ID == 10) {
    //   setSelectedIndex(row.ID);
    //   setMoyOnayPopUp(true);
    //   handleFileType(row.ID);
    //   setDurumId(row.DURUM_ID);
    //   setCloseType(row.KAPANIS_TIP_ID)
    // }
  }

  const handleSinglePopUp = (row) => {
    //Ihbarname Süresi Dolum Tarihi çıkması için
    row.DURUM_ID == 22 && row.KAPANIS_TIP_ID == 3 ? setIhbarnameSuresiDolumTarihiVisible(true) : setIhbarnameSuresiDolumTarihiVisible(false);

    //SAP AÇILMA İŞLEMİ YORUMLARI
    //Şube kapanıyor ise
    if (row.DURUM_ID == 5 && row.KAPANIS_TIP_ID == 4) {
      //Şube kapanıyor ise ve kapanan şube bilgisi varsa
      if (row.KAPATILAN_SUBELER != "-") {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin ve kendisine bağlı ${row.KAPATILAN_SUBELER} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      //Şube kapanıyor ise ve kapanan şube bilgisi yoksa
      else {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID);
    }
    //Şube kapanışı dışındaki durumlar için(DURUM_IDLER KONTROL EDİLECEK)
    else if ((row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 1) ||
      (row.DURUM_ID == 13 && row.KAPANIS_TIP_ID == 2) ||
      (row.DURUM_ID == 7 && row.KAPANIS_TIP_ID == 3) ||
      (row.DURUM_ID == 6 && row.KAPANIS_TIP_ID == 5)) {
      if (row.KAPATILAN_SUBELER != "-") {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin ve kendisine bağlı ${row.KAPATILAN_SUBELER} 'nin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      //Şube kapanıyor ise ve kapanan şube bilgisi yoksa
      else {
        setYorumAciklama(`${row.BOLGE}'ye bağlı ${row.SERVIS_KOD} kodlu ${row.SERVIS_AD} servisinin mali açıdan uygun olduğunda SAP’de kapatılması için yardımınızı rica ederiz.`);
      }
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID);
    }


    else {
      setSelectedIndex(row.ID);
      setSinglePopUp(true);
      setYorumAciklama('');
      setDurumId(row.DURUM_ID);
      setCloseType(row.KAPANIS_TIP_ID)
    }
  }


  const handleFilePopUp = (row) => {
    setSelectedIndex(row.ID);
    getReceiptAllFiles(row.ID)
    setFilePopUp(true);
  }

  const handleYorum = (row) => {
    setSelectedIndex(row.ID);
    setTarihcePopUp(true);
  }

  const getReceiptAllFiles = (receiptNumber) => {
    setFileList([]);
    setLoading(true);
    if (!receiptNumber) {
      return;
    }
    var images = []
    axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 2).then(response => {
      setFileList(Array.isArray(response.data) ? response.data : [])
      setLoading(false)
    });
  }

  const getApolloTodo = () => {
    setLoading(true)
    axios.get("/GetApolloTodoList/2").then((response) => {
      const Todo = response.data;
      if (Todo.length === 0) {
        setTodoData([]);
        setLoading(false);
      } else {
        setTodoData(Todo);
        setLoading(false);
      }
    });
  }

  const getMoyOnayText = (row) => {
    setLoading(true)
    axios.get("/GetMOYOnayText/" + row.ID).then((response) => {
      const text = response.data;
      if (text.length === 0) {
        setYorumAciklama('');
        setLoading(false);
      } else {
        setLoading(false);
        setYorumAciklama(text);
        setSelectedIndex(row.ID);
        setSinglePopUp(true);
        setDurumId(row.DURUM_ID);
        setCloseType(row.KAPANIS_TIP_ID)
      }
    });
  }

  const setCheckMenuItem = (id) => {
    if (checkedMenu?.includes(id)) {
      var checkedMenuControl = checkedMenu?.filter((item) => item !== id);
      setCheckedMenu(checkedMenuControl);
    }
    else {
      setCheckedMenu([...checkedMenu, id]);
    }
  }

  const setNewWindowOpen = (item) => {
    //get file data from GetReceiptFilesSpecial api
    setLoading(true);
    axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
      .then((response) => {
        const res = response.data[0];
        var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
        if (res?.DOSYA_TIPI?.includes('image')) {
          var image = new Image();
          image.src = FileData;
          var w = window.open("");
          w.document.write(image.outerHTML);
          w.document.title = res.DOSYA_ADI;
          w.document.close();
        } else {
          var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
          openBlobInNewTab(blobData);
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
    // if (item?.DOSYA_TIPI?.includes('image')) {
    //   var image = new Image();
    //   image.src = FileData;
    //   var w = window.open("");
    //   w.document.write(image.outerHTML);
    //   w.document.title = item.DOSYA_ADI;
    //   w.document.close();
    // } else {
    //   var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
    //   openBlobInNewTab(blobData);
    // }
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleSaveTodoList = (itemValue) => {
    if (checkedMenu.length < todoData.length) {
      setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
      setUyariTip("error");
      setUyari(true);
      return;
    }
    const data = {
      ApplicationId: selectedIndex,
      Confirm: true,
      UserId: "", //okta
      OpenCloseType: 2
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('SetTodoOnay', data, config).then((response) => {
      var res = response.data[0];
      if (res.ErrorCode === '1000') {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("error");
        setUyari(true);
        setLoading(false);
        setTodoPopUp(false);

      }
      if (res.ErrorCode === 0) {
        setresponseMessage(res.ErrorDescription)
        setUyariTip("success");
        setUyari(true);
        setLoading(false);
        setTodoPopUp(false);
        handleGetCloseApplication(1);
        checkedMenu([]);
      }
    }).catch(error => {
      setLoading(false);
      setTodoPopUp(false);
    });
  }
  const handleFileType = (basvuruId) => {
    axios.get(`/GetFileTypeByIdForClosing/` + basvuruId)
      .then((response) => {
        const res = response.data;
        setFileTypeData(res);
      }).catch(error => {
      });
  }




  return (
    <Page sx={styles.root}>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}>
        </Alert>
      </Snackbar>
      <Container sx={styles.container1} maxWidth="xl">
        <Card >
          <CardHeader
            title="Onay Bekleyenler"
            subheader={generalData.length ? `${filteredData.length} / ${generalData.length} kayıt` : undefined}
          />
          <Divider />
          <CardContent >
            <Grid container spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  size="small"
                  fullWidth
                  label="Ara"
                  placeholder="Bölge, il/ilçe, servis bilgisi..."
                  value={searchText}
                  onChange={(event) => setSearchText(event.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={bolgeSecenekleri}
                  value={filtreBolge}
                  onChange={(event, value) => setFiltreBolge(value)}
                  renderInput={(params) => <TextField {...params} label="Bölge" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={servisTipiSecenekleri}
                  value={filtreServisTipi}
                  onChange={(event, value) => setFiltreServisTipi(value)}
                  renderInput={(params) => <TextField {...params} label="Servis Tipi" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={kapanisTipiSecenekleri}
                  value={filtreKapanisTipi}
                  onChange={(event, value) => setFiltreKapanisTipi(value)}
                  renderInput={(params) => <TextField {...params} label="Kapanış Tipi" />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                <Autocomplete
                  size="small"
                  options={durumSecenekleri}
                  value={filtreDurum}
                  onChange={(event, value) => setFiltreDurum(value)}
                  renderInput={(params) => <TextField {...params} label="Durum" />}
                />
              </Grid>
              {filtreAktifMi && (
                <Grid>
                  <Button size="small" startIcon={<ClearIcon />} onClick={filtreleriTemizle}>
                    Filtreleri Temizle
                  </Button>
                </Grid>
              )}
            </Grid>
            <TableContainer sx={{ maxHeight: 560, overflow: 'auto' }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Kapanış tipi</TableCell>
                    <TableCell align="left">Son Onay Veren</TableCell>
                    <TableCell align="left">Onay Beklenen</TableCell>
                    <TableCell align="left">Bolge</TableCell>
                    <TableCell align="left">İl-İlçe</TableCell>
                    <TableCell align="left">ServisTipi</TableCell>
                    <TableCell align="left">Servis Bilgi</TableCell>
                    <TableCell align="left">Servis</TableCell>
                    <TableCell align="left">Şube Kodu</TableCell>
                    <TableCell align="left">Şube Merkezi</TableCell>
                    <TableCell align="left">Yorumlar</TableCell>
                    <TableCell align="left">Belgeler</TableCell>
                    <TableCell align="left">Aksiyon</TableCell>
                    <TableCell align="left">Onay/Red</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData?.length ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow key={row.ID ?? index}
                      style={row.ID === selectedIndex ? { backgroundColor: "rgba(255, 152, 0, 0.16)" }
                        : {}}
                    >
                      <TableCell align="left">{row.KAPANIS_TIP}</TableCell>
                      <TableCell align="left">{row.DURUM}</TableCell>
                      <TableCell align="left">{row.SONRAKI_ADIM_ACIKLAMA}</TableCell>
                      <TableCell align="left">{row.BOLGE}</TableCell>
                      <TableCell align="left">{row.IL_ILCE}</TableCell>
                      <TableCell align="left">{row.SERVIS_TIPI}</TableCell>
                      <TableCell align="left">
                        <ExpandableComment
                          Comment={row.SERVIS_BILGI}
                          CommentLimit={100}
                          DarkColor={selectedIndex != row.ID ? false : true} />
                      </TableCell>
                      <TableCell align="left">{row.SERVIS}</TableCell>
                      <TableCell align="left">{row.KAPATILAN_SUBELER}</TableCell>
                      {row.KAPANIS_TIP_ID == 4 ?
                        <TableCell align="left">{row.MERKEZ}</TableCell>
                        : <TableCell align="left" />}
                      <TableCell align="left">
                        <Tooltip title="Yorum Geçmişi">
                          <IconButton
                            size="small"
                            onClick={() => handleYorum(row)}
                            style={{ backgroundColor: '#19ecff', color: 'white' }}
                          >
                            <CommentOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="left">
                        <Tooltip title="Belgeler">
                          <IconButton
                            size="small"
                            onClick={() => handleFilePopUp(row)}
                            style={{ backgroundColor: '#FF7F00', color: 'white' }}
                          >
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      {(row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 22) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 7) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 1 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 2) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 10) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 5) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 18) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 13) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 20) ||
                        (row.KAPANIS_TIP_ID == 2 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 22) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 7) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 3 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 4 && row.DURUM_ID == 5) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 6) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 14) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 24) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 2) ||
                        (row.KAPANIS_TIP_ID == 5 && row.DURUM_ID == 22)
                        //  && row.ACILIS_TIP_ID != 5 
                        ?
                        <TableCell align="left">
                          <Tooltip title="Aksiyonlar">
                            <IconButton
                              size="small"
                              onClick={() => {
                                handleActionPopUp(row)
                                setKapanisTipId(row.KAPANIS_TIP_ID)
                                setState({
                                  kural1: false
                                });
                              }}
                              style={{ backgroundColor: '#FF4F00', color: 'white' }}
                            >
                              <ExtensionIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        : <TableCell align="left" />
                      }
                      <TableCell align="left">
                        <Tooltip title="Onayla / Reddet">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setKapanisTipId(row.KAPANIS_TIP_ID)
                              handleSinglePopUp(row)
                            }
                            }
                            style={{ backgroundColor: '#32CD32', color: 'white' }}
                          >
                            <DoneAllIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  )) : (
                    <TableRow>
                      <TableCell colSpan={15} align="center" style={{ padding: 32 }}>
                        {generalData.length
                          ? 'Filtrelere uyan kayıt bulunamadı.'
                          : (loading ? 'Kayıtlar yükleniyor...' : 'Onay bekleyen kayıt bulunmamaktadır.')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredData.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage="Sayfa başı kayıt:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
            />
          </CardContent>
          <Dialog
            open={singlePopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setSinglePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Onayla &amp; Reddet
              <IconButton
                onClick={() => {
                  setSinglePopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={1}>
                {IhbarnameSuresiDolumTarihiVisible && <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 12
                  }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap["tr"]}>
                    <DatePicker
                      label={'İhbarname Süresi Dolum Tarihi'}
                      format={'dd.MM.yyyy'}
                      minDate={currentDate}
                      value={ihbarnameSuresiDolumTarihi}
                      onChange={
                        (date) => {
                          setIhbarnameSuresiDolumTarihi(date)
                        }
                      }
                      slotProps={{
                        textField: {
                          color: 'primary',
                          variant: 'outlined',
                          error: moment(ihbarnameSuresiDolumTarihi, 'dd.MM.yyyy').isValid() ? false : RequiredIhbarSuresiDolumTarihi,
                          fullWidth: true
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>}
                <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    lg: 12
                  }}>
                  <TextField
                    size="small"
                    id="desc"
                    autoComplete="no"
                    multiline
                    error={yorumAciklama?.length > 0 ? false : Required}
                    rows={10}
                    value={yorumAciklama}
                    onChange={(event) => setYorumAciklama(
                      event.target.value
                    )}
                    fullWidth
                    label='Yorum'
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => handleReject()}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                Reddet
              </Button>
              <Button
                color="secondary"
                onClick={() => handleSave()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={filePopUp}
            onClose={() => setFilePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: {
                width: 480,
                height: 560,
                maxWidth: '90vw',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column'
              }
            }}
          >
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
              {`Belgeler${fileList?.length ? ` (${fileList.length})` : ''}`}
              <IconButton
                onClick={() => setFilePopUp(false)}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              {fileList?.length ? (
                <List sx={{ flex: 1, overflow: 'auto', py: 0 }}>
                  {fileList.map((item, index) => (
                    <React.Fragment key={item.DOSYA_ID}>
                      {index > 0 && <Divider component="li" />}
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => setNewWindowOpen(item)}>
                          <ListItemIcon>
                            <InsertDriveFileOutlinedIcon style={{ color: '#FF9800' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={item.DOSYA_ADI}
                            secondary={item.ContentType}
                          />
                        </ListItemButton>
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, color: 'text.secondary' }}>
                  {loading ? (
                    <>
                      <CircularProgress size={28} />
                      <Typography variant="body2">Dosyalar yükleniyor...</Typography>
                    </>
                  ) : (
                    <>
                      <FolderIcon fontSize="large" />
                      <Typography variant="body2">Dosya bulunmamaktadır.</Typography>
                    </>
                  )}
                </Box>
              )}
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                onClick={() => setFilePopUp(false)}
                color="secondary"
                variant="contained"
              >
                Kapat
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={tarihcePopUp}
            fullWidth
            maxWidth="lg"
            onClose={event => setTarihcePopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
            <DialogContent>
              <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={2} />
            </DialogContent>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={event => setTarihcePopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Dialog>
          <Dialog
            open={todoPopUp}
            fullWidth
            maxWidth="sm"
            onClose={() => setTodoPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              Yapılması Gereken Adımlar
              <IconButton
                onClick={() => {
                  setTodoPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 1 }}>
                Adımları tamamlamadan devam edemezsiniz!
              </Typography>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    {
                      todoData?.map((item) => (
                        <TableRow key={item.ID}>
                          <TableCell align="left" style={{ width: '50px' }}>
                            <FormControlLabel
                              value="top"
                              control={(
                                <Checkbox
                                  color="primary"
                                  checked={checkedMenu.includes(item?.ID) ? true : false}
                                  onChange={() => setCheckMenuItem(item?.ID)}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell align="left">
                            {item.ACIKLAMA}
                          </TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                color="secondary"
                onClick={() => setTodoPopUp(false)}
                aria-label="close"
                component="span"
                variant="contained"
                endIcon={<BlockIcon />}
                style={{ backgroundColor: '#ff0000', color: 'white' }}
              >
                KAPAT
              </Button>
              <Button
                color="secondary"
                onClick={() => handleBeforeConfirm()}
                aria-label="save"
                component="span"
                variant="contained"
                style={{ backgroundColor: '#008000', color: 'white' }}
                endIcon={<CheckCircleOutlineIcon />}
              >
                Onayla
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={moyOnOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              MOY On Onay Adımları
              <IconButton
                onClick={() => {
                  setMoyOnOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                documentTypeNumber={6} openClose={2} />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setMoyOnOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={moyOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setMoyOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              MOY Onay Adımları
              <IconButton
                onClick={() => {
                  setMoyOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                documentTypeNumber={27} openClose={2} />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setMoyOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={byOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setBYOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              BY Onay Aksiyonlar
              <IconButton
                onClick={() => {
                  setBYOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={2}>
                {closeType == 1 || closeType == 5 ?
                  <Grid
                    size={{
                      xs: 12,
                      md: 6
                    }}>
                    <FormControl component="fieldset" sx={styles.formControl}>
                      <FormLabel component="legend">
                        Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                          }
                          label="Fesih Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi?"
                        />
                      </FormGroup>
                      <FormHelperText>
                        İşlemleri tamamlamadan devam edemezsiniz!!
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  : null}
                {closeType != 1 ?
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={documentType}
                      openClose={2} />
                  </Grid>
                  : null}
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setBYOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={ibraProtokoluPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setibraProtokoluPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              BY İbra Protokolü Adımları
              <IconButton
                onClick={() => {
                  setibraProtokoluPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={2}>
                {closeType == 1 || closeType == 2 || closeType == 3 || closeType == 5 ?
                  <Grid
                    size={{
                      xs: 12,
                      md: 6
                    }}>
                    <FormControl component="fieldset" sx={styles.formControl}>
                      <FormLabel component="legend">
                        Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                          }
                          label="İbra Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi? ?"
                        />
                      </FormGroup>
                      <FormHelperText>
                        İşlemleri tamamlamadan devam edemezsiniz!!
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  : null}
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                    documentTypeNumber={28} openClose={2} />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setibraProtokoluPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={kapanisPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setkapanisPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              MOY Servis Kapanış Finali
              <IconButton
                onClick={() => {
                  setkapanisPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                documentTypeNumber={29} openClose={2} />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setkapanisPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={bySonOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setBYSonOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              BY Son Onay Aksiyonlar
              <IconButton
                onClick={() => {
                  setBYSonOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Grid container spacing={2}>
                {closeType == 2 ?
                  <Grid
                    size={{
                      xs: 12,
                      md: 6
                    }}>
                    <FormControl component="fieldset" sx={styles.formControl}>
                      <FormLabel component="legend">
                        Servis Kapanış süreci için aşağıdaki adımları tamamladınız mı?
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox checked={kural1} onChange={handleChange} name="kural1" />
                          }
                          label="Fesih Protokolü MOY’a ulaştırılmak üzere kargoya verildi mi?"
                        />
                      </FormGroup>
                      <FormHelperText>
                        İşlemleri tamamlamadan devam edemezsiniz!!
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  : null}
                {closeType != 2 ?
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1} documentTypeNumber={7}
                      openClose={2} />
                  </Grid>
                  : null}
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setBYSonOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={moySonOnayPopUp}
            fullWidth
            maxWidth="xl"
            onClose={() => setmoySonOnayPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{ textAlign: 'center' }}
            >
              MOY Son Onay Aksiyonlar
              <IconButton
                onClick={() => {
                  setmoySonOnayPopUp(false);
                }}
                aria-label="close"
                sx={styles.closeButton}
                component="span"
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <UploadFile basvuruId={selectedIndex} documentType={fileTypeData} dosyaAdet={1}
                documentTypeNumber={8}
                openClose={2} />
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setmoySonOnayPopUp(false)}
              >
                Tamam
              </Button>
            </DialogActions>
          </Dialog>
          <Divider />
        </Card>
      </Container>
    </Page >
  );
}

export default CloseConfirm;
